package com.example.shared

object Constants {
    const val SHOW_SECTIONS_PARAM = "showSections"
}